//Create a Vue Plugin to inject a function called handleResponse

export const VueErrorHandler = {
    install(Vue) {
        Vue.prototype.$error = async function (call) {
            try {
                const response = await call();
                return [null, response]
            } catch (e) {
                return [e, null]
            }
        }
    }
}
